/** Recorded attendance for this class, across a date range. */
import { useOutletContext, useParams } from 'react-router-dom';
import { readFragment } from 'gql.tada';
import AttendanceReport from '../AttendanceReport';
import { ScheduleBlockFields } from '../../Schedules/useScheduleBlocks';
import type { ClassDetailContext } from '../classDetailTypes';

function ClassAttendancePage() {
  const { schoolSlug, yearSlug, courseSlug, classOfferingId } = useParams();
  const { offering, isAdmin } = useOutletContext<ClassDetailContext>();

  // Attendance is a property of the schedule block, so the report needs them
  // to tell "nothing recorded" from "this class never records attendance".
  const blocks = (offering.scheduleBlocks ?? []).map(
    (block) => readFragment(ScheduleBlockFields, block)
  );

  return (
    <AttendanceReport
      classOfferingId={offering.id}
      scheduleBlocks={blocks}
      canManage={isAdmin}
      schedulePath={`/app/${schoolSlug}/years/${yearSlug}/courses/${courseSlug}/classes/${classOfferingId}/schedule`}
    />
  );
}

export default ClassAttendancePage;
